"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeStylableDirectiveRules = exports.addStylableDirectiveRules = exports.getSpxResolverImport = exports.hexAlphaImport = exports.fontThemesImport = exports.jsModulesImport = void 0;
var injections_1 = require("./injections");
var consts_1 = require("../consts");
var defaultIncludeDirectives = {
    breakpoints: true,
    siteColors: true,
    fontClasses: true,
    additionalJsModules: false,
    spxResolver: false,
    hexAlpha: false,
};
var wrapCssDirectives = function (css) {
    return "/* START STYLABLE DIRECTIVE RULES */\n".concat(css, "\n/* END STYLABLE DIRECTIVE RULES */\n");
};
var removeCssDirectives = function (css) {
    return css.replace(/\/\* START STYLABLE DIRECTIVE RULES \*\/\n[\s\S]*\n\/\* END STYLABLE DIRECTIVE RULES \*\/\n/, '');
};
var siteVars = ":import {-st-from: '".concat(consts_1.SITE_ST_CSS_PATH, "'; -st-named: site_1_1, site_2_1, site_3_1, site_4_1, site_5_1, site_1_2, site_2_2, site_3_2, site_4_2, site_5_2, site_1_3, site_2_3, site_3_3, site_4_3, site_5_3, site_1_4, site_2_4, site_3_4, site_4_4, site_5_4, site_1_5, site_2_5, site_3_5, site_4_5, site_5_5, color_11, color_12, color_13, color_14, color_15, color_18, color_36, color_37, color_38, color_39, color_40, color_41, color_42, color_43, color_44, color_45, color_46, color_47, color_48, color_49, color_50, color_51, color_52, color_53, color_54, color_55, color_56, color_57, color_58, color_59, color_60, color_61, color_62, color_63, color_64, color_65;}\n");
var fontThemeClasses = ":import {-st-from: '".concat(consts_1.SITE_ST_CSS_PATH, "'; -st-named: font_0, font_1, font_2, font_3, font_4, font_5, font_6, font_7, font_8, font_9, font_10;}\n");
var panelFontThemeClasses = ":import {-st-from: '".concat(consts_1.SITE_ST_CSS_PATH, "'; -st-named: panel_font_0 as font_0, panel_font_1 as font_1, panel_font_2 as font_2, panel_font_3 as font_3, panel_font_4 as font_4, panel_font_5 as font_5, panel_font_6 as font_6, panel_font_7 as font_7, panel_font_8 as font_8, panel_font_9 as font_9, panel_font_10 as font_10;}\n");
exports.jsModulesImport = ":import {-st-from: '".concat(consts_1.wixMediaUrlName, "';-st-default: ").concat(consts_1.wixMediaUrlFormatter, ";}");
exports.fontThemesImport = ":import {-st-from: '".concat(consts_1.wixFontThemesName, "';-st-named: font_0, font_1, font_2, font_3, font_4, font_5, font_6, font_7, font_8, font_9, font_10;}");
exports.hexAlphaImport = ":import {-st-from: '".concat(consts_1.wixHexAlphaName, "';-st-default: ").concat(consts_1.wixHexAlphaFormatter, ";}");
var getSpxImportPath = function (_a) {
    var spx = _a.spx, keepSpxUnit = _a.keepSpxUnit, shouldNormalizeSpx = _a.shouldNormalizeSpx;
    var isScale = (spx === null || spx === void 0 ? void 0 : spx.resolverType) === 'scale' && (spx === null || spx === void 0 ? void 0 : spx.refWidth);
    if (keepSpxUnit) {
        if (shouldNormalizeSpx && isScale) {
            return "".concat(consts_1.normalizedSpxName, "-").concat(spx.refWidth);
        }
        return consts_1.wixSpxName;
    }
    // For each spx refWidth, the viewer will register a JS module that resolves the px value
    return isScale ? "".concat(consts_1.wixSpxName, "-").concat(spx.refWidth) : consts_1.wixSpxFixedName;
};
var getSpxResolverImport = function (options) {
    var importPath = getSpxImportPath(options);
    return ":import {-st-from: '".concat(importPath, "'; -st-default: ").concat(consts_1.wixSpxResolver, ";}");
};
exports.getSpxResolverImport = getSpxResolverImport;
var addStylableDirectiveRules = function (stCss, isMobile, include, options) {
    if (include === void 0) { include = defaultIncludeDirectives; }
    if (options === void 0) { options = {}; }
    return wrapCssDirectives((include.breakpoints ? (0, injections_1.generateStylableBreakpoints)(isMobile) + '\n' : '') +
        (include.siteColors ? siteVars : '') +
        (include.additionalJsModules ? exports.jsModulesImport : '') +
        (include.fontClasses ? (options.usePanelThemeFonts ? panelFontThemeClasses : fontThemeClasses) : '') +
        (include.spxResolver ? (0, exports.getSpxResolverImport)(options) : '') +
        (include.hexAlpha ? exports.hexAlphaImport : '')) + stCss;
};
exports.addStylableDirectiveRules = addStylableDirectiveRules;
var removeStylableDirectiveRules = function (stCss) {
    return removeCssDirectives(stCss) // TODO: Deprecate the replace logic
        .replace(new RegExp(siteVars, 'g'), '')
        .replace(new RegExp(exports.jsModulesImport, 'g'), '')
        .replace(new RegExp(":vars {\\s+".concat(consts_1.mobileMediaQueryVarName, ":\\s.*;\\s}\\n"), 'gm'), '');
};
exports.removeStylableDirectiveRules = removeStylableDirectiveRules;
//# sourceMappingURL=directives.js.map